import React from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import mailsent from '../assets/images/icons/mail_sent.svg'
import logocolor from '../assets/images/logocolor.png'


const CheckEmail = ({ email, component }) => {
    return (
        <div className="crPgBr mx-438">
            <div className="crPg">

                <div className="crPgFrm v2 crPgFrmIps">
                    <div className="crPgLogo text-center mx-438">
                        <img src={logocolor} className='img-fluid' alt="Logo" />
                    </div>
                    <div className="text-center pt-2 pb-4">
                        <img src={mailsent} className='img-fluid' alt="mail_sent" />
                    </div>
                    <div className="crPgWclTx crPgWcl-tx-color pb-2 mb-2">
                        <h4 className="pb-2">Please check your email</h4>
                        <p className="v2">A email has been send to {(email)}. Please check for an email from company and click on the included link to reset your {component}.</p>
                    </div>
                    <div className="d-grid crPgbtn pt-2">
                        <Link to="/" className="btn btn-primary">
                            Back To Home
                        </Link>
                    </div>

                </div>

            </div>
        </div>
    )
}

CheckEmail.propTypes = {
    email: PropTypes.any.isRequired,
    component: PropTypes.any.isRequired,
};
export default CheckEmail;